export default __webpack_public_path__ + "static/media/onboard_new_plant_image.55c57d31.svg";